import axios from "axios";
import {closeNotify, showErrorNotify, showInfoNotify, showSuccessNotify, showWarningNotify} from "./ShowNotify";

export const downloadFile = (url, fileName) => {
    return new Promise(function (resolve, reject) {
        showInfoNotify("Đang tải file, vui lòng chờ trong giây lát!")
        axios({
            url: url,
            method: 'GET',
            timeout: 600000,
            responseType: 'blob', // important
            headers: {
                Authorization: localStorage.getItem('token')
            }
        }).then(async (res) => {
            closeNotify();
            if (res.data && res.data.size > 0) {
                let fileNameFromSv = res.headers['attachmentfilename'];
                let blob = new Blob([res.data]);
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileNameFromSv ? fileNameFromSv : fileName;
                link.click();
                link.remove();
                resolve('true');
            } else {
                let url = res.headers['downloadurl'];
                if (url) {
                    const response = await axios.get(url, {
                        responseType: 'blob',
                    });
                    let fileNameFromSv = res.headers['attachmentfilename'];
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([response.data]));
                    link.download = fileNameFromSv ? fileNameFromSv : fileName;
                    link.click();
                    link.remove();
                    resolve('true');
                } else {
                    showWarningNotify("File không khả dụng, vui lòng thử lại hoặc liên hệ quản trị viên");
                    resolve('true');
                }
            }
        }).catch(err => {
            showErrorNotify("Có lỗi xảy ra, vui lòng thử lại hoặc liên hệ quản trị viên");
            reject('false');
        })
    });
};

export const processZipFile = (url, file) => {
    return new Promise(function (resolve, reject) {
        showInfoNotify("Đang xử lí file, vui lòng chờ trong giây lát!");
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('file', file);
        axios.post(url, formData, {
            timeout: 600000,
            responseType: 'blob', // important
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': token
            },
        }).then((res) => {
            if (res.data && res.data.size > 0) {
                let fileNameFromSv = res.headers['attachmentfilename'];
                let blob = new Blob([res.data]);
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileNameFromSv ? fileNameFromSv : 'ket_qua.xlsx';
                link.click();
                showSuccessNotify("Kiểm tra file kết quả");
                resolve('true');
            } else {
                showSuccessNotify("Đã xử lí thành công toàn bộ file");
                resolve('true');
            }
        }).catch(err => {
            showErrorNotify("Xử lí file bị lỗi. Vui lòng kiểm tra lại file hoặc liên hệ quản trị viên!");
            resolve('false');
        });
    });

};

export const downloadFilePost = (url, fileName, data) => {
    return new Promise(function (resolve, reject) {
        showInfoNotify("Đang tải file, vui lòng chờ trong giây lát!")
        axios({
            url: url,
            method: 'POST',
            data: data,
            timeout: 600000,
            responseType: 'blob', // important
            headers: {
                Authorization: localStorage.getItem('token')
            }
        },).then((res) => {
            closeNotify();
            if (res.data && res.data.size > 0) {
                let fileNameFromSv = res.headers['attachmentfilename'];
                let blob = new Blob([res.data]);
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileNameFromSv ? fileNameFromSv : fileName;
                link.click();
            } else {
                showWarningNotify("File không khả dụng, vui lòng thử lại hoặc liên hệ quản trị viên");
            }
            resolve('true');
        }).catch(err => {
            showErrorNotify("Có lỗi xảy ra, vui lòng thử lại hoặc liên hệ quản trị viên");
            resolve('false');
        })
    });
};

export const downloadFilePut = (url, fileName, data) => {
    return new Promise(function (resolve, reject) {
        showInfoNotify("Đang tải file, vui lòng chờ trong giây lát!")
        axios({
            url: url,
            method: 'PUT',
            data: data,
            timeout: 600000,
            responseType: 'blob', // important
            headers: {
                Authorization: localStorage.getItem('token')
            }
        },).then((res) => {
            closeNotify();
            if (res.data && res.data.size > 0) {
                let fileNameFromSv = res.headers['attachmentfilename'];
                let blob = new Blob([res.data]);
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileNameFromSv ? fileNameFromSv : fileName;
                link.click();
            } else {
                showWarningNotify("File không khả dụng, vui lòng thử lại hoặc liên hệ quản trị viên");
            }
            resolve('true');
        }).catch(err => {
            showErrorNotify("Có lỗi xảy ra, vui lòng thử lại hoặc liên hệ quản trị viên");
            resolve('false');
        })
    });
};

export const openNewTab = (url) => {
    showInfoNotify("Đang tải file, vui lòng chờ trong giây lát!")
    axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // important
        headers: {
            Authorization: localStorage.getItem('token')
        }
    }).then((res) => {
        closeNotify();
        if (res.data && res.data.size > 0) {
            window.open(URL.createObjectURL(res.data));
        } else {
            showWarningNotify("File không khả dụng, vui lòng thử lại hoặc liên hệ quản trị viên");
        }
    }).catch(err => {
        showErrorNotify(err.message ? err.message : "Có lỗi xảy ra, vui lòng thử lại hoặc liên hệ quản trị viên");
    })
};

export const printContent = (url) => {
    return new Promise(function (resolve, reject) {
        showInfoNotify("Đang tải file, vui lòng chờ trong giây lát!")
        axios({
            url: url,
            method: 'GET',
            responseType: 'blob', // important
            headers: {
                Authorization: localStorage.getItem('token')
            }
        }).then((res) => {
            closeNotify();
            const myBlob = res.data
            if (myBlob) {
                let objectURL = URL.createObjectURL(myBlob);
                document.querySelector('#pdf-frame').src = '';
                document.querySelector('#pdf-frame').src = objectURL;
                URL.revokeObjectURL(myBlob);
            }
        }).then(
            function () {
                window.setTimeout(function () {
                    document.querySelector('#pdf-frame').contentWindow.print();
                    resolve('true');
                }, 1000)
            });

    });
};


export function printFile({
                              url,
                              method = 'POST',      // hoặc 'GET'
                              data = undefined,      // body cho POST
                              params = undefined,    // query cho GET/POST
                              headers = {},
                              timeout = 60000,
                              onStart = () => {
                              },
                              onDone = () => {
                              },
                              onError = () => {
                              }
                          }) {
    onStart();

    return axios({
        url,
        method,
        data,
        params,
        responseType: 'blob',
        headers: {
            Authorization: localStorage.getItem('token'),
            ...headers
        },
        timeout
    })
        .then(async (res) => {
            const blob = res.data;
            const ct = (res.headers['content-type'] || '').toLowerCase();

            // Nếu server trả JSON lỗi thay vì file
            if (ct.includes('application/json')) {
                try {
                    const text = await blob.text();
                    throw new Error(text);
                } catch (e) {
                    throw e;
                }
            }

            // Tạo objectURL
            const objectURL = URL.createObjectURL(blob);

            // In trực tiếp nếu là PDF / image
            if (ct.includes('application/pdf') || ct.startsWith('image/')) {
                return printViaIframe(objectURL);
            }

            // Nếu là Excel hoặc định dạng khác:
            // - Cách tốt nhất: backend trả PDF nếu mục tiêu là in.
            // - Ở client, ta fallback: mở tải về, hoặc mở tab mới (trình duyệt không render xlsx để in).
            triggerDownload(objectURL, inferFilename(res.headers) || 'file');
            return 'downloaded';
        })
        .then((result) => {
            onDone();
            return result;
        })
        .catch((err) => {
            onError(err);
            throw err;
        });
}

// In bằng iframe, đảm bảo chờ load
function printViaIframe(objectURL) {
    return new Promise((resolve, reject) => {
        const iframe = document.getElementById('print-frame');
        if (!iframe) {
            URL.revokeObjectURL(objectURL);
            return reject(new Error('print-frame not found'));
        }

        const onLoad = () => {
            try {
                // Một số trình duyệt cần delay rất ngắn để layout ổn định
                setTimeout(() => {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                    // Thu hồi URL sau khi print (delay nhỏ để an toàn)
                    setTimeout(() => {
                        URL.revokeObjectURL(objectURL);
                        resolve('printed');
                    }, 500);
                }, 50);
            } catch (e) {
                URL.revokeObjectURL(objectURL);
                reject(e);
            } finally {
                iframe.removeEventListener('load', onLoad);
            }
        };

        iframe.addEventListener('load', onLoad);
        // Gán src cuối cùng để lắng nghe onload chính xác
        iframe.src = objectURL;
    });
}

function triggerDownload(objectURL, filename = 'file') {
    const a = document.createElement('a');
    a.href = objectURL;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Thu hồi sau một nhịp
    setTimeout(() => URL.revokeObjectURL(objectURL), 1000);
}

function inferFilename(headers) {
    const cd = headers['content-disposition'];
    if (!cd) return null;
    // Content-Disposition: attachment; filename="abc.pdf"
    const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(cd);
    if (match && match[1]) {
        try {
            return decodeURIComponent(match[1]);
        } catch {
            return match[1];
        }
    }
    return null;
}